import gsap from "gsap";

const initMenu = (): void => {
  const dropdownTriggers = () =>
    document.querySelectorAll(".js-menu-dropdown-trigger");

  const attachDropdownTrigger = (dropdownTrigger: Element) => {
    dropdownTrigger.addEventListener("click", () => {
      const timeline = getDropdownTriggerTimeline(dropdownTrigger);

      dropdownTriggerTimelines
        .filter((target) => target !== timeline)
        .forEach((target) => target.reverse());

      if (dropdownTrigger.closest(".is-open") instanceof Element) {
        timeline.seek(timeline.totalDuration());
        timeline.reverse();
      } else {
        timeline.play();
      }
    });
  };

  dropdownTriggers().forEach(attachDropdownTrigger);

  const generateDropdownTriggerTimeline = (dropdownTrigger: Element) => {
    const menuItem = dropdownTrigger.closest(".js-menu-item");
    const dropdown = menuItem.querySelector(".js-menu-dropdown");

    const response = gsap.timeline({
      paused: true,
      ease: "power4",
      onStart: () => menuItem.classList.add("is-open"),
      onReverseComplete: () => menuItem.classList.remove("is-open"),
    });

    response.data = dropdownTrigger;

    gsap.set(dropdown, {
      attr: {
        "aria-expanded": "false",
        "aria-hidden": "true",
      },
      height: 0,
      overflow: "hidden",
    });

    gsap.set(dropdown.querySelectorAll("a"), {
      attr: {
        tabindex: "-1",
      },
    });

    response.add("open");

    response.to(
      dropdown,
      {
        height: "auto",
        attr: {
          "aria-expanded": "true",
          "aria-hidden": "false",
        },
      },
      "open"
    );

    response.to(
      dropdown.querySelectorAll("a"),
      {
        attr: {
          tabindex: "0",
        },
      },
      "open"
    );

    response.to(
      dropdownTrigger.querySelector(".js-menu-chevron"),
      {
        scaleY: -1,
        duration: 0.2,
      },
      "open"
    );

    return response;
  };

  const dropdownTriggerTimelines = [...dropdownTriggers()].map(
    generateDropdownTriggerTimeline
  );

  const getDropdownTriggerTimeline = (dropdownTrigger: Element) =>
    dropdownTriggerTimelines.find(
      (timeline) => timeline.data === dropdownTrigger
    );

  [...dropdownTriggers()]
    .filter((trigger) => trigger.closest(".is-open") instanceof Element)
    .map(getDropdownTriggerTimeline)
    .forEach((timeline) => timeline.seek(timeline.totalDuration()));
};

export default initMenu();
